import { CHECKBOX_STATUS } from 'ui/checkbox/checkboxStatus';
import { FolderClosed } from 'ui/icons';
import { FolderRow } from 'ui/indexPages/folders/folderRow';
import { CheckboxGridCell } from 'ui/indexPages/tables/cells';
import { SearchParamLink } from 'ui/utility/SearchParamLink/SearchParamLink';
import { isSelectionFolder } from 'utils/contexts/selection';

import { GraphQLCampaignSubfolder } from '../types';
import { CampaignFolderOverflowMenu } from './CampaignFolderOverflowMenu';
import { useSelectionContext } from './contexts/SelectionContext';
import { FOLDER_ID_SEARCH_PARAM, PAGE_SEARCH_PARAM } from '../constants';
import { Favorite } from '../../../ui/indexPages/Favorite/Favorite';
import { useSelector } from 'react-redux';
import { selectIsCampaignsFavoritesFeatureFlagOn } from 'core/userContext';
import { StyledContainer } from '../CampaignIndexPage.styles';
import { useFavorite } from '../../../ui/indexPages/Favorite/hooks/useFavorite';

type CampaignFolderItemProps = {
  folder: GraphQLCampaignSubfolder;
};

export const CampaignFolderRow = ({ folder }: CampaignFolderItemProps) => {
  const isCampaignsFavoritesFeatureFlagOn = useSelector(selectIsCampaignsFavoritesFeatureFlagOn);
  const {
    isSelected: isFavoriteSelected,
    isVisible,
    onFavoriteClick,
    rowProps,
  } = useFavorite({
    isEnabled: isCampaignsFavoritesFeatureFlagOn,
    isFavorite: folder.isFavorite,
  });
  const { bulk, toggleBulkSelection } = useSelectionContext();
  const isSelected = Boolean(bulk.find((item) => isSelectionFolder(item) && item.id === folder.id));

  return (
    <FolderRow id={folder.id.toString()} {...rowProps}>
      <StyledContainer>
        <CheckboxGridCell
          handleClick={() => toggleBulkSelection(folder)}
          id={folder.id.toString()}
          status={isSelected ? CHECKBOX_STATUS.CHECKED : CHECKBOX_STATUS.UNCHECKED}
        />
        <Favorite isVisible={isVisible} isSelected={isFavoriteSelected} onClick={onFavoriteClick} />
      </StyledContainer>

      <FolderClosed data-test="folder-icon" />
      <SearchParamLink
        searchParams={{
          [FOLDER_ID_SEARCH_PARAM]: folder.id.toString(),
        }}
        deleteSearchParams={[PAGE_SEARCH_PARAM]}
      >
        {folder.name}
      </SearchParamLink>
      <CampaignFolderOverflowMenu
        folder={folder}
        onFavoriteClick={onFavoriteClick}
        isFavoriteSelected={isFavoriteSelected}
      />
    </FolderRow>
  );
};
